<template>
  <div>
    <Loading :center="false" v-show="loading" />
    <div v-show="!loading">
      <Molded>
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="4" xl="4">
            <SelectStatic title="Fuso Horário" fieldTarget="timeZone" :data="[
              { content: 'UTC-02:00 Fernando de Noronha', id: 'UTC-02' },
              { content: 'UTC-03:00 Brasília', id: 'E. South America Standard Time' },
              { content: 'UTC-04:00 Amazônia', id: 'Central Brazilian Standard Time' },
              { content: 'UTC-05:00 Acre', id: 'SA Pacific Standard Time' },
            ]" :markFormDirty="true" v-model="parameterSystem.timeZone" />
          </b-col>
        </b-row>
      </Molded>
      <br>
      <Molded>
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="12" xl="12">
            <RadioGroup title="Ao enviar um E-mail, para quem deseja que os clientes respondam?" field="email"
              :formName="formName" :options="[
                { text: 'Personalizado', value: true },
                { text: 'Usuário Logado', value: false },
              ]" v-model="parameterSystem.isReplyCompany" />
          </b-col>
        </b-row>
        <b-row v-if="parameterSystem.isReplyCompany">
          <b-col xs="12" sm="12" md="12" lg="4" xl="4">
            <InputText title="Nome" field="name" :formName="formName" :required="true" :maxLength="100"
              v-model="parameterSystem.replyName" />
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="4" xl="4">
            <InputText title="E-mail" field="email" :formName="formName" :required="true" :maxLength="100"
              v-model="parameterSystem.replyTo" />
          </b-col>
        </b-row>
      </Molded>
    </div>
  </div>
</template>

<script>
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import SelectStatic from "@nixweb/nixloc-ui/src/component/forms/SelectStatic";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup.vue";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";

import ParameterSystem from "@/components/modules/adm/parameter/ParameterSystem.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  components: {
    Loading,
    SelectStatic,
    Molded,
    RadioGroup,
    InputText
  },
  name: "ParameterSystem",
  data() {
    return {
      formName: "updateParameterSystem",
      parameterSystem: new ParameterSystem(),
      urlUpdate: "/api/v1/adm/parameter-system/update",
      urlGetById: "/api/v1/adm/parameter-system/get-by-companyid",
      loading: true,
    };
  },
  created() {
    this.getById();
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapActions("generic", ["putApi", "getApi"]),
    ...mapMutations("generic", ["addLoading", "removeLoading", "addEvent"]),
    ...mapMutations("validation", ["resetValidation", "removeFormDirty"]),
    ...mapMutations("user", ["updateParameterRental"]),
    getById() {
      let params = { url: this.urlGetById, id: this.id };
      this.getApi(params).then((response) => {
        this.parameterSystem.update(response.content);
        let self = this;
        setTimeout(function () {
          self.loading = false;
          self.removeLoading(["panel"]);
          self.removeFormDirty();
        }, 100);
      });
    },
    update() {
      let params = { url: this.urlUpdate, obj: this.parameterSystem };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.updateParameterRental(response.content);
          this.addEvent({ name: "renovateToken" });
        }
        this.removeLoading(["saveSaveCancel"]);
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "saveSaveCancel") {
          this.update();
        }
      },
      deep: true,
    },
  },
};
</script>
